@if (uiConfiguration) {
  <form [formGroup]="termDetails">
    @if (uiConfiguration.showTerm && uiConfiguration.registryDefinedTerm) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'orders.term2' | transloco }}</mat-label>
            <input matInput [disabled]="true" [value]="uiConfiguration.registryDefinedTerm" />
          </mat-form-field>
        </div>
      </div>
    }
    @if ((uiConfiguration.showTerm && uiConfiguration.showExpiryDate) ||
      (uiConfiguration.showTerm && uiConfiguration.showInfinityTerm) ||
      (uiConfiguration.showExpiryDate && uiConfiguration.showInfinityTerm)) {
      <div
        class="flex-container padding-top">
        <div class="flex-item form-field">
          <mat-radio-group formControlName="selectedTermType"
            [attr.aria-label]="'orders.lienTermOrInfiniteLienRadio' | transloco" (change)="onTermSelectionChange($event)">
            @if (uiConfiguration.showTerm) {
              <mat-radio-button class="radio-button"
                [value]="termInYearsSelection" data-testid="term-radio-button">{{ 'orders.termInYears' | transloco }}</mat-radio-button>
            }
            @if (uiConfiguration.showExpiryDate) {
              <mat-radio-button class="radio-button"
                [value]="expiryDateSelection" data-testid="expiry-date-radio-button">{{ 'common.labels.expiryDate' | transloco }}</mat-radio-button>
            }
            @if (uiConfiguration.showInfinityTerm) {
              <mat-radio-button class="radio-button"
              [value]="infiniteSelection" data-testid="infinite-radio-button">{{ 'orders.infinite' | transloco }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </div>
    }
    @if (uiConfiguration.showTerm && selectedTermType === termInYearsSelection && !uiConfiguration.registryDefinedTerm) {
      <div
        class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.term2' | transloco }}</mat-label>
            <mat-select formControlName="term" data-testid="term-dropdown">
              @for (length of termOptions; track length) {
                <mat-option [value]="length.value" data-testid="term"
                  [attr.data-testid]="'term-option-' + length.value">
                  {{ length.viewValue }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <lib-error-bubble [control]="termDetails.get('term')!" [message]="termError$"></lib-error-bubble>
        </div>
      </div>
    }
    @if (uiConfiguration.showExpiryDate && selectedTermType === expiryDateSelection) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'common.labels.expiryDate' | transloco }}</mat-label>
            <input matInput [matDatepicker]="expiryDate" formControlName="expiryDate"
              [placeholder]="'common.labels.yyyyMmDd' | transloco" data-testid="expiry-date-field">
            <mat-datepicker-toggle matSuffix [for]="expiryDate"></mat-datepicker-toggle>
            <mat-datepicker #expiryDate></mat-datepicker>
          </mat-form-field>
          <lib-error-bubble [control]="termDetails.get('expiryDate')!"
          [message]="expiryDateError$"></lib-error-bubble>
        </div>
      </div>
    }
  </form>
}